import React, { useState, useEffect } from 'react'
import { supabase } from '../supabase'
import WorkOrder from './WorkOrder'

const FREQ_OPTIONS = [
  { v:'weekly',     l:'Semanal (cada semana)' },
  { v:'biweekly',   l:'Cada 2 semanas' },
  { v:'triweekly',  l:'Cada 3 semanas' },
  { v:'fortweekly', l:'Cada 4 semanas' },
  { v:'monthly',    l:'Mensual' },
  { v:'bimonthly',  l:'Bimestral (cada 2 meses)' },
  { v:'custom',     l:'Personalizado' },
  { v:'one-time',   l:'Una sola vez' },
]
const DAYS = ['','Mon','Tue','Wed','Thu','Fri','Sat','Sun']
const DAY_ES = { '':'Flexible', Mon:'Lunes', Tue:'Martes', Wed:'Miércoles', Thu:'Jueves', Fri:'Viernes', Sat:'Sábado', Sun:'Domingo' }
const DAY_BADGE = { Mon:'L', Tue:'M', Wed:'Mi', Thu:'J', Fri:'V', Sat:'S', Sun:'D' }

const COMPAT_LEVELS = ['ok','prefer','only','dislike']
const COMPAT_ES = { ok:'OK', prefer:'Prefiere', only:'Solo acepta', dislike:'No acepta' }
const COMPAT_STYLE = {
  ok:      { background:'#f1f3f4', color:'#5f6368' },
  prefer:  { background:'#e1f5ee', color:'#085041' },
  only:    { background:'#eeedfe', color:'#3c3489' },
  dislike: { background:'#fcebeb', color:'#a32d2d' },
}
const AV_COLORS = [
  {bg:'#fdeef3',fg:'#c03060'},{bg:'#e6f1fb',fg:'#0c447c'},
  {bg:'#e1f5ee',fg:'#085041'},{bg:'#eeedfe',fg:'#3c3489'},
  {bg:'#faece7',fg:'#4a1b0c'},{bg:'#faeeda',fg:'#854f0b'},
  {bg:'#eaf3de',fg:'#27500a'},{bg:'#fbeaf0',fg:'#72243e'},
]

function initials(name) {
  return (name||'?').split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase()
}

const emptyClient = {
  name:'', nickname:'', phone:'', email:'', address:'', city:'', zip:'',
  entry_code:'', frequency:'weekly', preferred_day:'', preferred_time:'',
  default_hours:2, default_rate:'', is_airbnb:false, is_realtor:false,
  video_url:'', guest_prefs:'', notes:'', notes_list:[], is_active:true,
  next_date:'', custom_schedule:'', source:'', date_started:'',
  billing_name:'', billing_address:'', billing_city:'', billing_phone:'', billing_email:''
}

function SattarInvoice({ history, companySettings }) {
  const [month, setMonth] = useState(() => {
    const now = new Date()
    return now.getFullYear() + '-' + String(now.getMonth()+1).padStart(2,'0')
  })
  const [showSettings, setShowSettings] = useState(false)
  const [billingA, setBillingA] = useState(() => {
    try { return JSON.parse(localStorage.getItem('sattar_billing_a')||'{}') } catch(e) { return {} }
  })
  const [billingB, setBillingB] = useState(() => {
    try { return JSON.parse(localStorage.getItem('sattar_billing_b')||'{}') } catch(e) { return {} }
  })

  function saveBilling(which, key, val) {
    if (which === 'a') {
      const updated = {...billingA, [key]: val}
      setBillingA(updated)
      localStorage.setItem('sattar_billing_a', JSON.stringify(updated))
    } else {
      const updated = {...billingB, [key]: val}
      setBillingB(updated)
      localStorage.setItem('sattar_billing_b', JSON.stringify(updated))
    }
  }

  function generateInv(billing, rate, label, invSuffix) {
    const [year, mon] = month.split('-').map(Number)
    const entries = (history||[]).filter(h => {
      const d = new Date(h.cleaned_date+'T12:00:00')
      return d.getFullYear()===year && d.getMonth()+1===mon
    }).sort((a,b)=>new Date(a.cleaned_date)-new Date(b.cleaned_date))

    if (!entries.length) { alert('No visits this month'); return }

    const qty = entries.length
    const total = qty * rate
    const dateList = entries.map(h => new Date(h.cleaned_date+'T12:00:00').toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'})).join(', ')
    const monthLabel = new Date(year, mon-1, 1).toLocaleDateString('en-US',{month:'long',year:'numeric'})
    const co = companySettings || {}
    const invNum = 'KC-' + year + '-' + String(mon).padStart(2,'0') + '-' + invSuffix

    const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>Invoice — ${billing.name||'Sattar'} — ${monthLabel}</title>
<style>
* { box-sizing:border-box; margin:0; padding:0; }
body { font-family:Arial,sans-serif; padding:40px; color:#202124; max-width:700px; margin:0 auto; }
.header { background:#e8547a; padding:20px 28px; border-radius:10px 10px 0 0; display:flex; justify-content:space-between; align-items:center; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
.co { color:#fff; }
.co b { font-size:20px; font-family:Georgia,serif; }
.co small { font-size:11px; opacity:.85; display:block; margin-top:3px; }
.badge { background:rgba(255,255,255,0.2); border:1.5px solid rgba(255,255,255,0.5); border-radius:8px; padding:8px 14px; text-align:right; color:#fff; }
.body { border:2px solid #e8547a; border-top:none; border-radius:0 0 10px 10px; padding:24px 28px; }
.grid2 { display:grid; grid-template-columns:1fr 1fr; gap:20px; margin-bottom:20px; padding-bottom:16px; border-bottom:1.5px solid #f0d0da; }
.lbl { font-size:9px; text-transform:uppercase; letter-spacing:.1em; color:#e8547a; font-weight:700; margin-bottom:4px; }
.val { font-size:14px; font-weight:600; }
.sm { font-size:12px; color:#5f6368; line-height:1.7; }
table { width:100%; border-collapse:collapse; margin-bottom:16px; }
th { background:#e8547a; color:#fff; padding:9px 12px; text-align:left; font-size:10px; text-transform:uppercase; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
th:last-child { text-align:right; }
td { padding:10px 12px; font-size:12px; border-bottom:1px solid #f0d0da; }
td:last-child { text-align:right; font-weight:600; }
.totals { display:flex; justify-content:flex-end; margin-bottom:20px; }
.tbox { min-width:200px; }
.tline { display:flex; justify-content:space-between; padding:5px 0; font-size:12px; color:#5f6368; border-bottom:1px solid #f0d0da; }
.tfinal { display:flex; justify-content:space-between; padding:10px 14px; background:#e8547a; border-radius:8px; margin-top:8px; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
.tfinal span { color:#fff; font-weight:700; }
.pay { background:#fdf0f3; border-radius:8px; padding:12px 16px; margin-bottom:16px; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
.footer { text-align:center; font-size:11px; color:#9aa0a6; border-top:1px solid #f0d0da; padding-top:14px; line-height:1.8; }
@media print { body { padding:20px; } }
</style></head>
<body>
<div class="header">
  <div class="co">
    <b>${co.name || "Kitty's Cleaning Services"} 🐈</b>
    <small>${co.address || '6427 Wilcox Ave, Bell, CA 90201'} · ${co.phone || '(310) 425-3195'}</small>
    <small>${co.email || 'info@kittyscleaningservices.com'}</small>
  </div>
  <div class="badge">
    <div style="font-size:10px;text-transform:uppercase;letter-spacing:.08em">Invoice</div>
    <div style="font-size:18px;font-weight:700;margin-top:2px">#${invNum}</div>
    <div style="font-size:10px;margin-top:2px;opacity:.8">Due on receipt</div>
  </div>
</div>
<div class="body">
  <div class="grid2">
    <div>
      <div class="lbl">Bill To</div>
      <div class="val">${billing.name || 'Sattar & Associates Inc.'}</div>
      <div class="sm" style="margin-top:4px">
        ${billing.address ? billing.address + '<br>' : ''}
        ${billing.contact ? billing.contact + '<br>' : ''}
        ${billing.email ? billing.email : ''}
      </div>
    </div>
    <div>
      <div class="lbl">Invoice Details</div>
      <div class="sm">
        <strong>Invoice #:</strong> ${invNum}<br>
        <strong>Period:</strong> ${monthLabel}<br>
        <strong>Service:</strong> ${label}<br>
        <strong>Days:</strong> ${qty}
      </div>
    </div>
  </div>

  <table>
    <thead><tr><th style="width:45%">Description</th><th>Dates</th><th style="width:8%;text-align:center">Qty</th><th style="width:10%;text-align:right">Rate</th><th style="width:12%;text-align:right">Amount</th></tr></thead>
    <tbody>
      <tr>
        <td><strong>${label}</strong><br><span style="font-size:11px;color:#777">${dateList}</span></td>
        <td>${monthLabel}</td>
        <td style="text-align:center">${qty}</td>
        <td style="text-align:right">$${rate}.00</td>
        <td>$${total.toFixed(2)}</td>
      </tr>
    </tbody>
  </table>

  <div class="totals">
    <div class="tbox">
      <div class="tline"><span>Subtotal</span><span>$${total.toFixed(2)}</span></div>
      <div class="tline"><span>Tax</span><span>$0.00</span></div>
      <div class="tfinal"><span>Total Due</span><span style="font-size:20px">$${total.toFixed(2)}</span></div>
    </div>
  </div>

  <div class="pay">
    <div style="font-size:9px;text-transform:uppercase;letter-spacing:.1em;color:#e8547a;font-weight:700;margin-bottom:7px">💳 Payment Methods</div>
    ${co.zelle ? '<div style="font-size:12px;margin-bottom:4px"><strong>Zelle:</strong> ' + co.zelle + '</div>' : ''}
    <div style="font-size:12px;margin-bottom:4px"><strong>Check:</strong> Payable to "${co.name || "Kitty's Cleaning Services"}"</div>
    <div style="font-size:11px;color:#e8547a;margin-top:4px">Please reference invoice #${invNum}</div>
  </div>

  <div class="footer">
    Thank you for your continued business! 🐈<br>
    ${co.phone || '(310) 425-3195'} · ${co.email || 'info@kittyscleaningservices.com'}
  </div>
</div>
<script>window.onload=()=>window.print()</script>
</body></html>`
    const win = window.open('','_blank')
    win.document.write(html)
    win.document.close()
  }

  const fieldStyle = {fontSize:11,padding:'4px 7px',border:'1px solid #e3e5e8',borderRadius:6,background:'#fff',width:'100%',marginBottom:4}

  return (
    <div style={{marginBottom:10,padding:'10px 12px',background:'#e8f5e9',borderRadius:8,border:'1px solid #a5d6a7'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:8}}>
        <div style={{fontSize:11,fontWeight:600,color:'#1b5e20'}}>🏢 Facturas Sattar</div>
        <button style={{fontSize:10,padding:'3px 8px',border:'1px solid #a5d6a7',borderRadius:6,background:'#fff',color:'#2e7d32',cursor:'pointer'}}
          onClick={()=>setShowSettings(p=>!p)}>⚙️ Configurar destinatarios</button>
      </div>

      {showSettings && (
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:10,padding:10,background:'#fff',borderRadius:8,border:'1px solid #c8e6c9'}}>
          <div>
            <div style={{fontSize:10,fontWeight:600,color:'#1b5e20',marginBottom:5}}>Factura A — $80/día (Oficina principal)</div>
            {[['name','Nombre empresa'],['address','Dirección'],['contact','Contacto'],['email','Email']].map(([k,l])=>(
              <div key={k}><div style={{fontSize:9,color:'#80868b',marginBottom:1}}>{l}</div>
              <input style={fieldStyle} value={billingA[k]||''} onChange={e=>saveBilling('a',k,e.target.value)}/></div>
            ))}
          </div>
          <div>
            <div style={{fontSize:10,fontWeight:600,color:'#1b5e20',marginBottom:5}}>Factura B — $30/día (Pasillo)</div>
            {[['name','Nombre empresa'],['address','Dirección'],['contact','Contacto'],['email','Email']].map(([k,l])=>(
              <div key={k}><div style={{fontSize:9,color:'#80868b',marginBottom:1}}>{l}</div>
              <input style={fieldStyle} value={billingB[k]||''} onChange={e=>saveBilling('b',k,e.target.value)}/></div>
            ))}
          </div>
        </div>
      )}

      <div style={{display:'flex',gap:6,alignItems:'center',flexWrap:'wrap'}}>
        <input type="month" value={month} onChange={e=>setMonth(e.target.value)}
          style={{fontSize:11,padding:'4px 6px',border:'1px solid #a5d6a7',borderRadius:6,background:'#fff'}}/>
        <button onClick={()=>generateInv(billingA, 80, 'Office Cleaning — Sattar & Associates', 'SAT-A')}
          style={{fontSize:11,padding:'5px 12px',border:'none',borderRadius:6,background:'#2e7d32',color:'#fff',cursor:'pointer',fontWeight:500}}>
          📄 Factura $80/día
        </button>
        <button onClick={()=>generateInv(billingB, 30, 'Hallway Cleaning — 12954 Hawthorne Blvd', 'SAT-B')}
          style={{fontSize:11,padding:'5px 12px',border:'none',borderRadius:6,background:'#388e3c',color:'#fff',cursor:'pointer',fontWeight:500}}>
          📄 Factura $30/día
        </button>
      </div>
      <div style={{fontSize:10,color:'#4caf50',marginTop:4}}>Dos facturas separadas · misma fecha · info guardada automáticamente</div>
    </div>
  )
}


export default function Clients() {
  const [clients, setClients] = useState([])
  const [staff, setStaff] = useState([])
  const [compat, setCompat] = useState({})
  const [history, setHistory] = useState({})
  const [clientInvoices, setClientInvoices] = useState({})
  const [selected, setSelected] = useState(null)
  const [form, setForm] = useState(emptyClient)
  const [search, setSearch] = useState('')
  const [filter, setFilter] = useState('all')
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [isNew, setIsNew] = useState(false)
  const [error, setError] = useState('')
  const [workOrderClient, setWorkOrderClient] = useState(null)

  useEffect(() => { fetchAll() }, [])

  async function fetchAll() {
    setLoading(true)
    const [{ data: c, error: ce }, { data: s }, { data: cp }, { data: h }, { data: inv }, { data: jb }] = await Promise.all([
      supabase.from('clients').select('*').order('name'),
      supabase.from('staff').select('*').order('name'),
      supabase.from('client_staff_compat').select('*'),
      supabase.from('cleaning_history').select('*').order('cleaned_date', { ascending: false }),
      supabase.from('invoices').select('*').order('created_at', { ascending: false }),
      supabase.from('jobs').select('client_id,scheduled_date,start_time,status').not('start_time','is',null).neq('status','skipped').neq('status','estimate'),
    ])
    if (ce) console.error('clients fetch error:', ce)
    setClients(c || [])
    setStaff(s || [])
    const cm = {}
    ;(cp || []).forEach(r => {
      if (!cm[r.client_id]) cm[r.client_id] = {}
      cm[r.client_id][r.staff_id] = r.level
    })
    setCompat(cm)
    const hm = {}
    ;(h || []).forEach(r => {
      if (!hm[r.client_id]) hm[r.client_id] = []
      hm[r.client_id].push(r)
    })
    // Merge timed jobs into history (jobs with a start_time = we went)
    const seenDates = {}
    ;(jb || []).forEach(j => {
      if (!hm[j.client_id]) hm[j.client_id] = []
      if (!seenDates[j.client_id]) seenDates[j.client_id] = new Set(hm[j.client_id].map(h=>h.cleaned_date))
      if (!seenDates[j.client_id].has(j.scheduled_date)) {
        hm[j.client_id].push({ client_id: j.client_id, cleaned_date: j.scheduled_date, from_job: true })
        seenDates[j.client_id].add(j.scheduled_date)
      }
    })
    // Re-sort each client's history newest first
    Object.keys(hm).forEach(id => {
      hm[id].sort((a,b) => new Date(b.cleaned_date) - new Date(a.cleaned_date))
    })
    setHistory(hm)
    const im = {}
    ;(inv||[]).forEach(i => { if (!im[i.client_id]) im[i.client_id]=[]; im[i.client_id].push(i) })
    setClientInvoices(im)
    setLoading(false)
  }

  function selectClient(c) {
    setSelected(c.id)
    setForm({ ...emptyClient, ...c, notes_list: Array.isArray(c.notes_list) ? c.notes_list : [] })
    setIsNew(false)
    setError('')
  }

  function newClient() {
    setSelected('new')
    setForm({ ...emptyClient })
    setIsNew(true)
    setError('')
  }

  async function saveClient() {
    if (!form.name.trim()) { setError('El nombre es requerido'); return }
    setSaving(true)
    setError('')
    const payload = {
      name: form.name.trim(),
      nickname: form.nickname || '',
      phone: form.phone || '',
      email: form.email || '',
      address: form.address || '',
      city: form.city || '',
      zip: form.zip || '',
      entry_code: form.entry_code || '',
      drive_link: form.drive_link || '',
      frequency: form.frequency || 'weekly',
      preferred_day: form.preferred_day || '',
      preferred_time: form.preferred_time || '',
      default_hours: parseFloat(form.default_hours) || 2,
      default_rate: form.default_rate ? parseFloat(form.default_rate) : null,
      is_airbnb: !!form.is_airbnb,
      is_realtor: !!form.is_realtor,
      video_url: form.video_url || '',
      guest_prefs: form.guest_prefs || '',
      notes: form.notes || '',
      notes_list: form.notes_list || [],
      is_active: form.is_active !== false,
      next_date: form.next_date || null,
      custom_schedule: form.custom_schedule || '',
      source: form.source || '',
      date_started: form.date_started || null,
      billing_name: form.billing_name || null,
      billing_address: form.billing_address || null,
      billing_city: form.billing_city || null,
      billing_phone: form.billing_phone || null,
      billing_email: form.billing_email || null,
    }
    if (isNew) {
      const { data, error } = await supabase.from('clients').insert([payload]).select().single()
      if (error) { setError('Error al guardar: ' + error.message); setSaving(false); return }
      if (data) {
        setClients(prev => [...prev, data].sort((a,b) => a.name.localeCompare(b.name)))
        setSelected(data.id)
        setIsNew(false)
      }
    } else {
      const { data, error } = await supabase.from('clients').update(payload).eq('id', selected).select().single()
      if (error) { setError('Error al guardar: ' + error.message); setSaving(false); return }
      if (data) setClients(prev => prev.map(c => c.id === selected ? data : c))
    }
    setSaving(false)
  }

  async function deleteClient() {
    if (!window.confirm('¿Eliminar este cliente?')) return
    await supabase.from('clients').delete().eq('id', selected)
    setClients(prev => prev.filter(c => c.id !== selected))
    setSelected(null)
  }

  async function updateCompat(clientId, staffId, level) {
    setCompat(prev => ({ ...prev, [clientId]: { ...(prev[clientId]||{}), [staffId]: level } }))
    const { error } = await supabase.from('client_staff_compat').upsert(
      { client_id: clientId, staff_id: staffId, level },
      { onConflict: 'client_id,staff_id' }
    )
    if (error) console.error('compat error:', error)
  }

  const filtered = clients.filter(c => {
    if (filter === 'weekly' && c.frequency !== 'weekly') return false
    if (filter === 'biweekly' && c.frequency !== 'biweekly') return false
    if (filter === 'triweekly' && c.frequency !== 'triweekly') return false
    if (filter === 'fortweekly' && c.frequency !== 'fortweekly') return false
    if (filter === 'monthly' && c.frequency !== 'monthly') return false
    if (filter === 'custom' && c.frequency !== 'custom') return false
    if (filter === 'airbnb' && !c.is_airbnb) return false
    if (filter === 'realtor' && !c.is_realtor) return false
    if (search && !c.name.toLowerCase().includes(search.toLowerCase())) return false
    return true
  }).sort((a,b) => {
    // Inactive always at bottom
    if (a.is_active === false && b.is_active !== false) return 1
    if (b.is_active === false && a.is_active !== false) return -1
    return a.name.localeCompare(b.name)
  })

  return (
    <div style={s.wrap}>
      {/* LIST */}
      <div style={s.list}>
        <div style={s.listTop}>
          <input style={s.search} placeholder="Buscar cliente..." value={search}
            onChange={e => setSearch(e.target.value)} />
          <div style={s.filterRow}>
            {[['all','Todos'],['weekly','Semanal'],['biweekly','2 semanas'],['triweekly','3 semanas'],['fortweekly','4 semanas'],['monthly','Mensual'],['custom','Personalizado'],['airbnb','Airbnb'],['realtor','Realtor']].map(([v,l]) => (
              <button key={v} style={{...s.fchip,...(filter===v?s.fchipOn:{})}} onClick={()=>setFilter(v)}>{l}</button>
            ))}
          </div>
        </div>
        <div style={s.listScroll}>
          {loading ? <div style={s.loading}>Cargando...</div> :
            filtered.length === 0 ? <div style={s.loading}>Sin resultados</div> :
            filtered.map((c,i) => {
              const av = AV_COLORS[i % AV_COLORS.length]
              const hasWarn = Object.values(compat[c.id]||{}).some(v=>v==='dislike'||v==='only')
              return (
                <div key={c.id} style={{...s.row,...(selected===c.id?s.rowOn:{}),opacity:c.is_active===false?0.45:1}} onClick={()=>selectClient(c)}>
                  <div style={{...s.av,background:c.is_active===false?'#e0e0e0':''+av.bg,color:c.is_active===false?'#80868b':av.fg}}>{initials(c.name)}</div>
                  <div style={s.rowInfo}>
                    <div style={{...s.rowName,color:c.is_active===false?'#80868b':'#202124'}}>{c.name}</div>
                    <div style={s.rowSub}>{c.is_active===false?'Inactivo · ':''}{FREQ_OPTIONS.find(f=>f.v===c.frequency)?.l||c.frequency}</div>
                  </div>
                  <div style={{display:'flex',gap:2,flexDirection:'column',alignItems:'flex-end'}}>
                    {c.is_airbnb && <span style={{...s.badge,background:'#faeeda',color:'#854f0b'}}>Airbnb</span>}
                    {c.is_realtor && <span style={{...s.badge,background:'#eeedfe',color:'#3c3489'}}>Realtor</span>}
                    {hasWarn && <span style={{...s.badge,background:'#fcebeb',color:'#a32d2d'}}>★</span>}
                  </div>
                </div>
              )
            })
          }
        </div>
        <button style={s.addBtn} onClick={newClient}>+ Nuevo cliente</button>
      </div>

      {/* DETAIL */}
      <div style={s.detail}>
        {!selected ? (
          <div style={s.empty}><div style={{fontSize:40}}>🌸</div><div style={{fontSize:14,color:'#80868b',marginTop:8}}>Selecciona un cliente</div></div>
        ) : (
          <div style={s.profile}>
            <div style={s.profHead}>
              <div style={{...s.profAv,background:AV_COLORS[(clients.findIndex(c=>c.id===selected)||0)%AV_COLORS.length]?.bg||'#fdeef3',color:AV_COLORS[(clients.findIndex(c=>c.id===selected)||0)%AV_COLORS.length]?.fg||'#c03060'}}>
                {initials(form.name||'NC')}
              </div>
              <div style={{flex:1}}>
                <input style={s.nameInput} value={form.name}
                  onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Nombre del cliente"/>
                <div style={{fontSize:11,color:'#80868b',marginTop:2}}>{form.address}{form.city?`, ${form.city}`:''}</div>
              </div>
              <div style={s.actions}>
                {!isNew && <button style={s.delBtn} onClick={deleteClient}>Eliminar</button>}
                {!isNew && (
                  <button onClick={()=>setWorkOrderClient(clients.find(c=>c.id===selected))}
                    style={{fontSize:12,padding:'6px 12px',border:'1px solid #f4b8cc',borderRadius:8,
                      background:'#fdeef3',color:'#e8547a',cursor:'pointer',fontWeight:500}}>
                    📋 Work Order
                  </button>
                )}
                <button style={s.saveBtn} onClick={saveClient} disabled={saving}>
                  {saving?'Guardando...':'Guardar'}
                </button>
              </div>
            </div>
            {error && <div style={s.errorBar}>{error}</div>}
            <div style={s.body}>

              <Sec title="Programación">
                <div style={s.grid}>
                  <Fld label="Apodo / Nickname (aparece en el horario)">
                    <input style={s.input} value={form.nickname||''} placeholder="Ej: Ramm, Casa Verde..."
                      onChange={e=>setForm(f=>({...f,nickname:e.target.value}))}/>
                  </Fld>
                  <Fld label="Frecuencia">
                    <select style={s.input} value={form.frequency} onChange={e=>setForm(f=>({...f,frequency:e.target.value}))}>
                      {FREQ_OPTIONS.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
                    </select>
                  </Fld>
                  {form.frequency==='custom' && (
                    <Fld label="Descripción del horario personalizado">
                      <input style={s.input} value={form.custom_schedule||''} placeholder="Ej: Martes y Jueves cada 2 semanas"
                        onChange={e=>setForm(f=>({...f,custom_schedule:e.target.value}))}/>
                    </Fld>
                  )}
                  <Fld label="Día preferido">
                    <select style={s.input} value={form.preferred_day||''} onChange={e=>setForm(f=>({...f,preferred_day:e.target.value}))}>
                      {DAYS.map(d=><option key={d} value={d}>{DAY_ES[d]}</option>)}
                    </select>
                  </Fld>
                  <Fld label="Hora preferida">
                    <input style={s.input} value={form.preferred_time||''} placeholder="Ej: 9am – 2pm"
                      onChange={e=>setForm(f=>({...f,preferred_time:e.target.value}))}/>
                  </Fld>
                  <Fld label="Horas por visita">
                    <input style={s.input} type="number" value={form.default_hours} min="0.5" max="8" step="0.5"
                      onChange={e=>setForm(f=>({...f,default_hours:parseFloat(e.target.value)||2}))}/>
                  </Fld>
                  <Fld label="Tarifa habitual ($)">
                    <input style={s.input} type="number" value={form.default_rate||''} placeholder="0.00" min="0" step="5"
                      onChange={e=>setForm(f=>({...f,default_rate:e.target.value}))}/>
                  </Fld>
                  <Fld label="Próxima fecha esperada">
                    <input style={s.input} type="date" value={form.next_date||''}
                      onChange={e=>setForm(f=>({...f,next_date:e.target.value}))}/>
                  </Fld>
                </div>
              </Sec>

              <Sec title="Contacto y acceso">
                <div style={s.grid}>
                  <Fld label="Teléfono"><input style={s.input} value={form.phone||''} placeholder="(310) 555-0000" onChange={e=>setForm(f=>({...f,phone:e.target.value}))}/></Fld>
                  <Fld label="Correo"><input style={s.input} value={form.email||''} placeholder="cliente@correo.com" onChange={e=>setForm(f=>({...f,email:e.target.value}))}/></Fld>
                  <Fld label="Dirección">
                    <input style={s.input} value={form.address||''} placeholder="123 Oak St, Gardena, CA 90247"
                      onChange={e=>setForm(f=>({...f,address:e.target.value}))}
                      onBlur={e=>{
                        // Auto-split pasted full address into address + city
                        const val = e.target.value.replace(', USA','').replace(', United States','').trim()
                        const parts = val.split(',').map(p=>p.trim())
                        if (parts.length >= 3) {
                          const street = parts[0]
                          const city = parts[1]
                          const stateZip = parts.slice(2).join(', ')
                          setForm(f=>({...f, address:street, city:`${city}, ${stateZip}`}))
                        } else if (parts.length === 2) {
                          setForm(f=>({...f, address:parts[0], city:parts[1]}))
                        }
                      }}
                    />
                    <div style={{fontSize:10,color:'#9aa0a6',marginTop:2}}>
                      💡 Pega la dirección completa de Google Maps — se separará sola
                    </div>
                  </Fld>
                  <Fld label="Ciudad / CP"><input style={s.input} value={form.city||''} placeholder="Gardena, CA 90247" onChange={e=>setForm(f=>({...f,city:e.target.value}))}/></Fld>
                  <Fld label="Código de entrada"><input style={s.input} value={form.entry_code||''} placeholder="#4421 o Gate B7" onChange={e=>setForm(f=>({...f,entry_code:e.target.value}))}/></Fld>
                  <Fld label="Link Google Drive (fotos / checklist)">
                    <input style={s.input} value={form.drive_link||''} placeholder="https://drive.google.com/..." onChange={e=>setForm(f=>({...f,drive_link:e.target.value}))}/>
                    <div style={{fontSize:10,color:'#9aa0a6',marginTop:2}}>📁 El equipo verá un botón en su ruta para abrir este link</div>
                  </Fld>
                </div>
              </Sec>

              <Sec title="💳 Información de facturación">
                <div style={{fontSize:11,color:'#9aa0a6',marginBottom:8}}>Solo si es diferente al perfil — se usa en las facturas enviadas al cliente.</div>
                <div style={s.grid}>
                  <Fld label="Nombre en la factura"><input style={s.input} value={form.billing_name||''} placeholder="Ej: John Smith (dueño del Airbnb)" onChange={e=>setForm(f=>({...f,billing_name:e.target.value}))}/></Fld>
                  <Fld label="Email de facturación"><input style={s.input} value={form.billing_email||''} placeholder="email@ejemplo.com" onChange={e=>setForm(f=>({...f,billing_email:e.target.value}))}/></Fld>
                  <Fld label="Teléfono de facturación"><input style={s.input} value={form.billing_phone||''} placeholder="(310) 000-0000" onChange={e=>setForm(f=>({...f,billing_phone:e.target.value}))}/></Fld>
                  <Fld label="Dirección de facturación"><input style={s.input} value={form.billing_address||''} placeholder="123 Main St" onChange={e=>setForm(f=>({...f,billing_address:e.target.value}))}/></Fld>
                  <Fld label="Ciudad / Estado"><input style={s.input} value={form.billing_city||''} placeholder="Los Angeles, CA 90001" onChange={e=>setForm(f=>({...f,billing_city:e.target.value}))}/></Fld>
                </div>
              </Sec>

              <Sec title="Notas (se envían al equipo)">
                <div style={{fontSize:11,color:'#9aa0a6',marginBottom:8}}>Cada nota aparece como un item que el equipo puede marcar en su portal — agrega tantas como necesites.</div>
                <div style={{display:'flex',flexDirection:'column',gap:5,marginBottom:8}}>
                  {(form.notes_list||[]).map((note,i) => (
                    <div key={i} style={{display:'flex',alignItems:'center',gap:6,padding:'7px 10px',background:'#f8f9fa',borderRadius:8,fontSize:12}}>
                      <span style={{fontSize:13,color:'#e8547a'}}>☐</span>
                      <input style={{flex:1,border:'none',background:'none',fontSize:12,color:'#333'}}
                        value={note}
                        onChange={e=>setForm(f=>({...f,notes_list:f.notes_list.map((n,idx)=>idx===i?e.target.value:n)}))} />
                      <button style={{fontSize:13,border:'none',background:'none',color:'#ddd',cursor:'pointer'}}
                        onClick={()=>setForm(f=>({...f,notes_list:f.notes_list.filter((_,idx)=>idx!==i)}))}>×</button>
                    </div>
                  ))}
                  {(form.notes_list||[]).length===0 && (
                    <div style={{fontSize:11,color:'#bdc1c6',padding:'6px 0'}}>Sin notas todavía</div>
                  )}
                </div>
                <button type="button" style={{fontSize:12,padding:'6px 12px',border:'1px solid #e3e5e8',borderRadius:8,background:'#fff',color:'#e8547a',cursor:'pointer',fontWeight:600}}
                  onClick={()=>setForm(f=>({...f,notes_list:[...(f.notes_list||[]),'']}))}>
                  + Agregar nota
                </button>
              </Sec>

              <Sec title="Tipo de cliente">
                <div style={{display:'flex',gap:16,flexWrap:'wrap'}}>
                  <label style={s.toggle}><input type="checkbox" checked={!!form.is_airbnb} onChange={e=>setForm(f=>({...f,is_airbnb:e.target.checked}))}/><span>Propiedad Airbnb</span></label>
                  <label style={s.toggle}><input type="checkbox" checked={!!form.is_commercial} onChange={e=>setForm(f=>({...f,is_commercial:e.target.checked}))}/><span>Cliente comercial</span></label>
                  <label style={s.toggle}><input type="checkbox" checked={!!form.is_realtor} onChange={e=>setForm(f=>({...f,is_realtor:e.target.checked}))}/><span>Realtor</span></label>
                  <label style={s.toggle}><input type="checkbox" checked={form.is_active!==false} onChange={e=>setForm(f=>({...f,is_active:e.target.checked}))}/><span>Cliente activo</span></label>
                </div>
              </Sec>

              <Sec title="Fuente del cliente">
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
                  <Fld label="¿Cómo nos encontró?">
                    <select style={s.input} value={form.source||''} onChange={e=>setForm(f=>({...f,source:e.target.value}))}>
                      <option value="">Desconocido</option>
                      <option value="referral">Referido</option>
                      <option value="instagram">Instagram</option>
                      <option value="facebook">Facebook</option>
                      <option value="yelp">Yelp</option>
                      <option value="nextdoor">Nextdoor</option>
                      <option value="google">Google</option>
                      <option value="flyer">Volante</option>
                      <option value="repeat">Cliente recurrente</option>
                      <option value="other">Otro</option>
                    </select>
                  </Fld>
                  <Fld label="Fecha que empezó con nosotros">
                    <input style={s.input} type="date" value={form.date_started||''} onChange={e=>setForm(f=>({...f,date_started:e.target.value}))}/>
                  </Fld>
                </div>
              </Sec>

              {form.is_airbnb && (
                <Sec title="Configuración Airbnb">
                  <Fld label="URL de video de referencia">
                    <input style={s.input} value={form.video_url||''} placeholder="https://..." onChange={e=>setForm(f=>({...f,video_url:e.target.value}))}/>
                  </Fld>
                  <div style={{marginTop:8}}>
                    <div style={s.flabel}>Preferencias de huésped (predeterminado)</div>
                    <textarea style={s.textarea} value={form.guest_prefs||''} rows={4}
                      placeholder="Cama sofá abierta&#10;Cama principal: doblez tipo hotel&#10;Toallas enrolladas"
                      onChange={e=>setForm(f=>({...f,guest_prefs:e.target.value}))}/>
                  </div>
                </Sec>
              )}

              {!isNew && staff.length > 0 && (
                <Sec title="Compatibilidad con limpiadoras">
                  <div style={s.compatGrid}>
                    {staff.map(st => {
                      const level = (compat[selected]||{})[st.id] || 'ok'
                      return (
                        <div key={st.id} style={s.compatCell}>
                          <span style={s.compatName}>{st.name}</span>
                          <select style={{...s.compatSel,...COMPAT_STYLE[level]}} value={level}
                            onChange={e=>updateCompat(selected,st.id,e.target.value)}>
                            {COMPAT_LEVELS.map(l=><option key={l} value={l}>{COMPAT_ES[l]}</option>)}
                          </select>
                        </div>
                      )
                    })}
                  </div>
                </Sec>
              )}

              {!isNew && (
                <>
                <Sec title="Fechas de limpieza">
                {(() => {
                  const lastEntry = (history[selected]||[]).filter(h=>h.client_id===selected)[0]
                  const lastDate = lastEntry ? new Date(lastEntry.cleaned_date+'T12:00:00') : null

                  function calcNextDate(last, frequency) {
                    if (!last) return null
                    const d = new Date(last)
                    switch(frequency) {
                      case 'weekly':      d.setDate(d.getDate()+7);  break
                      case 'biweekly':    d.setDate(d.getDate()+14); break
                      case 'triweekly':   d.setDate(d.getDate()+21); break
                      case 'fortweekly':  d.setDate(d.getDate()+28); break
                      case 'monthly':     d.setMonth(d.getMonth()+1); break
                      case 'bimonthly':   d.setMonth(d.getMonth()+2); break
                      default: return null
                    }
                    return d
                  }

                  const autoNext = calcNextDate(lastDate, form.frequency)
                  const nextDisplay = form.next_date
                    ? new Date(form.next_date+'T12:00:00')
                    : autoNext

                  const today = new Date(); today.setHours(0,0,0,0)
                  const isOverdue = nextDisplay && nextDisplay < today

                  return (
                <div style={{background:'#f8f9fa',borderRadius:10,padding:'12px 14px',border:'1px solid #e3e5e8',marginBottom:8}}>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
                    <div>
                      <div style={{fontSize:10,color:'#9aa0a6',marginBottom:2}}>Última limpieza</div>
                      <div style={{fontSize:13,fontWeight:600,color:'#202124'}}>
                        {lastDate ? lastDate.toLocaleDateString('es-MX',{weekday:'short',month:'short',day:'numeric'}) : 'Sin historial'}
                      </div>
                    </div>
                    <div>
                      <div style={{fontSize:10,color:'#9aa0a6',marginBottom:2}}>Próxima fecha</div>
                      <div style={{fontSize:13,fontWeight:600,color:isOverdue?'#e24b4a':nextDisplay?'#185fa5':'#9aa0a6'}}>
                        {nextDisplay
                          ? nextDisplay.toLocaleDateString('es-MX',{weekday:'short',month:'short',day:'numeric'})
                          : '—'}
                        {isOverdue && <span style={{fontSize:10,marginLeft:4,color:'#e24b4a'}}>⚠ Vencida</span>}
                        {!form.next_date && autoNext && <span style={{fontSize:9,color:'#9aa0a6',display:'block',marginTop:1}}>calculada de historial</span>}
                        {form.next_date && <span style={{fontSize:9,color:'#185fa5',display:'block',marginTop:1}}>fijada manualmente</span>}
                      </div>
                    </div>
                  </div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
                    <div>
                      <div style={{fontSize:10,color:'#80868b',marginBottom:3}}>Agregar limpieza al historial</div>
                      <input style={s.input} type="date"
                        onChange={async e => {
                          if (!e.target.value) return
                          const { data } = await supabase.from('cleaning_history').insert([{
                            client_id: selected,
                            cleaned_date: e.target.value,
                            hours_actual: form.default_hours || 2,
                            staff_names: 'Manual',
                            team_note: 'Fecha corregida manualmente'
                          }]).select().single()
                          if (data) {
                            const hm = {...history}
                            if (!hm[selected]) hm[selected] = []
                            hm[selected] = [data, ...hm[selected]].sort((a,b)=>new Date(b.cleaned_date)-new Date(a.cleaned_date))
                            setHistory(hm)
                            // Clear manual next_date so auto-calc takes over
                            setForm(f=>({...f,next_date:''}))
                          }
                          e.target.value = ''
                        }}
                      />
                    </div>
                    <div>
                      <div style={{fontSize:10,color:'#80868b',marginBottom:3}}>Fijar próxima fecha (manual)</div>
                      <input style={s.input} type="date" value={form.next_date||''}
                        onChange={e=>setForm(f=>({...f,next_date:e.target.value}))}/>
                      {form.next_date && (
                        <button style={{fontSize:10,color:'#9aa0a6',border:'none',background:'none',cursor:'pointer',marginTop:3,padding:0}}
                          onClick={()=>setForm(f=>({...f,next_date:''}))}>
                          × Usar cálculo automático
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                  )
                })()}
              </Sec>

              <Sec title="Facturas">
                  {(clientInvoices[selected]||[]).filter(inv=>inv.status!=='void').length === 0
                    ? <div style={{fontSize:12,color:'#9aa0a6'}}>Sin facturas aún</div>
                    : (clientInvoices[selected]||[]).filter(inv=>inv.status!=='void').map(inv=>(
                        <div key={inv.id} style={{display:'flex',alignItems:'center',gap:8,padding:'6px 0',borderBottom:'1px solid #e3e5e8'}}>
                          <div style={{fontSize:11,color:'#e8547a',fontWeight:600,fontFamily:'monospace'}}>{inv.invoice_num}</div>
                          <div style={{flex:1,fontSize:11,color:'#80868b'}}>{new Date(inv.date+'T12:00:00').toLocaleDateString('es-MX',{month:'short',day:'numeric',year:'numeric'})}</div>
                          <div style={{fontSize:10,padding:'1px 7px',borderRadius:10,fontWeight:500,
                            background:inv.status==='paid'?'#e1f5ee':'#fff8e1',
                            color:inv.status==='paid'?'#085041':'#854f0b',
                            border:`1px solid ${inv.status==='paid'?'#5DCAA5':'#fac775'}`}}>
                            {inv.status==='paid'?'✅ Pagada':'⏳ Pendiente'}
                          </div>
                          <div style={{fontSize:12,fontWeight:600,color:'#202124'}}>${parseFloat(inv.amount).toFixed(2)}</div>
                        </div>
                      ))
                  }
                </Sec>

              <Sec title="Historial de limpiezas">
                  {/* Nueva factura */}
                  <button
                    onClick={() => {
                      localStorage.setItem('open_invoice_for_client', selected)
                      window.dispatchEvent(new CustomEvent('navigate-to', { detail: { tab: 'invoices' } }))
                    }}
                    style={{fontSize:11,padding:'5px 14px',border:'none',borderRadius:6,background:'#e8547a',color:'#fff',cursor:'pointer',fontWeight:500,marginBottom:10}}>
                    📄 Nueva factura
                  </button>
                  {/* Sattar split invoice */}
                  {(clients.find(c=>c.id===selected)?.name||'').toLowerCase().includes('sattar') && (
                    <SattarInvoice history={history[selected]||[]} companySettings={JSON.parse(localStorage.getItem('company_settings')||'{}')} />
                  )}
                  {(history[selected]||[]).length === 0
                    ? <div style={{fontSize:12,color:'#9aa0a6'}}>Sin historial aún</div>
                    : (history[selected]||[]).slice(0,15).map(h=>(
                        <div key={h.id} style={s.histRow}>
                          <div style={s.histDate}>{new Date(h.cleaned_date+'T12:00:00').toLocaleDateString('es-MX',{month:'short',day:'numeric',year:'numeric'})}</div>
                          <div style={{flex:1}}>
                            <div style={{fontSize:12,color:'#202124'}}>{h.staff_names||'Equipo'}</div>
                            {h.team_note&&<div style={{fontSize:11,color:'#80868b',fontStyle:'italic'}}>{h.team_note}</div>}
                          </div>
                          <div style={{fontSize:11,color:'#80868b',marginRight:6}}>{h.hours_actual}h</div>
                          <button style={{fontSize:13,border:'none',background:'none',color:'#ddd',cursor:'pointer',padding:'0 2px'}}
                            onClick={async()=>{
                              if(!window.confirm('¿Eliminar este registro del historial?')) return
                              await supabase.from('cleaning_history').delete().eq('id',h.id)
                              setHistory(prev=>({...prev,[selected]:prev[selected].filter(x=>x.id!==h.id)}))
                            }}>×</button>
                        </div>
                      ))
                  }
                </Sec>
              </> 
              )}
            </div>
          </div>
        )}
      </div>
      {workOrderClient && (
        <WorkOrder
          client={workOrderClient}
          onClose={()=>setWorkOrderClient(null)}
        />
      )}
    </div>
  )
}

function Sec({title,children}){return(<div style={{marginBottom:20}}><div style={{fontSize:10,fontWeight:600,textTransform:'uppercase',letterSpacing:'.06em',color:'#9aa0a6',marginBottom:8}}>{title}</div>{children}</div>)}
function Fld({label,children}){return(<div><div style={{fontSize:10,color:'#80868b',marginBottom:3}}>{label}</div>{children}</div>)}


// ── WorkOrder is rendered inside Clients component via portal ──
// (See workOrderClient state and button above)

const s = {
  wrap:{display:'flex',height:'100%',overflow:'hidden'},
  list:{width:220,borderRight:'1px solid #e3e5e8',display:'flex',flexDirection:'column',background:'#f8f9fa',flexShrink:0},
  listTop:{padding:'10px 10px 6px',borderBottom:'1px solid #e3e5e8'},
  search:{width:'100%',padding:'7px 10px',border:'1px solid #dadce0',borderRadius:8,fontSize:12,background:'#fff',marginBottom:6},
  filterRow:{display:'flex',gap:3,flexWrap:'wrap'},
  fchip:{fontSize:10,padding:'2px 7px',borderRadius:10,border:'1px solid #dadce0',background:'#fff',color:'#80868b',cursor:'pointer'},
  fchipOn:{background:'#fdeef3',color:'#c03060',borderColor:'#f4b8cc',fontWeight:500},
  listScroll:{flex:1,overflowY:'auto',padding:6},
  loading:{padding:16,fontSize:12,color:'#80868b',textAlign:'center'},
  row:{display:'flex',alignItems:'center',gap:8,padding:'8px',borderRadius:8,cursor:'pointer',marginBottom:2},
  rowOn:{background:'#fff',borderLeft:'3px solid #e8547a',paddingLeft:5},
  av:{width:30,height:30,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:600,flexShrink:0},
  rowInfo:{flex:1,minWidth:0},
  rowName:{fontSize:12,fontWeight:500,color:'#202124',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  rowSub:{fontSize:10,color:'#80868b',marginTop:1,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  badge:{fontSize:9,padding:'1px 4px',borderRadius:3,fontWeight:500},
  addBtn:{margin:8,padding:'8px',border:'1px dashed #dadce0',borderRadius:8,background:'none',fontSize:12,color:'#e8547a',fontWeight:500,cursor:'pointer'},
  detail:{flex:1,overflow:'hidden',display:'flex',flexDirection:'column'},
  empty:{flex:1,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'},
  profile:{flex:1,display:'flex',flexDirection:'column',overflow:'hidden'},
  profHead:{display:'flex',alignItems:'center',gap:12,padding:'14px 18px',borderBottom:'1px solid #e3e5e8',background:'#fff',flexShrink:0},
  profAv:{width:44,height:44,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,fontWeight:600,flexShrink:0},
  nameInput:{fontSize:18,fontWeight:600,border:'none',outline:'none',background:'transparent',color:'#202124',width:'100%'},
  actions:{display:'flex',gap:6},
  delBtn:{fontSize:12,padding:'6px 12px',border:'1px solid #e3e5e8',borderRadius:8,background:'#fff',color:'#80868b',cursor:'pointer'},
  saveBtn:{fontSize:12,padding:'6px 14px',border:'none',borderRadius:8,background:'#e8547a',color:'#fff',fontWeight:500,cursor:'pointer'},
  errorBar:{background:'#fcebeb',color:'#a32d2d',fontSize:12,padding:'8px 18px',borderBottom:'1px solid #f09595'},
  body:{flex:1,overflowY:'auto',padding:'16px 18px'},
  grid:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8},
  flabel:{fontSize:10,color:'#80868b',marginBottom:3},
  input:{width:'100%',padding:'6px 9px',border:'1px solid #e3e5e8',borderRadius:8,fontSize:12,background:'#f8f9fa',color:'#202124'},
  textarea:{width:'100%',padding:'8px 10px',border:'1px solid #e3e5e8',borderRadius:8,fontSize:12,background:'#f8f9fa',color:'#202124',resize:'vertical'},
  toggle:{display:'flex',alignItems:'center',gap:6,fontSize:12,color:'#444',cursor:'pointer'},
  compatGrid:{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:6},
  compatCell:{background:'#f8f9fa',borderRadius:8,padding:'6px 8px',display:'flex',alignItems:'center',justifyContent:'space-between'},
  compatName:{fontSize:11,color:'#202124'},
  compatSel:{fontSize:10,padding:'2px 4px',border:'1px solid #e3e5e8',borderRadius:4,cursor:'pointer'},
  histRow:{display:'flex',alignItems:'flex-start',gap:8,padding:'6px 0',borderBottom:'1px solid #e3e5e8'},
  histDate:{fontSize:11,color:'#80868b',width:60,flexShrink:0},
}
